import React from 'react'
import convertUnit from 'lib/unit'
import {RoboyuColorTheme} from '../../../types'
import {RoboyuAssetProps} from './RoboyuAssetProps'

export default function RoboyuDefault({
  width = convertUnit(519),
  height = convertUnit(673),
  colorTheme = 'blue',
  ...props
}: RoboyuAssetProps) {
  return (
    <svg
      {...props}
      width={width}
      height={height}
      viewBox="0 0 2000 2000"
      fill="none">
      <g filter="url(#filter0_d_4220_34576)">
        <path
          d="M747.5 1446.33C747.5 1309.33 858.55 1247.88 995.55 1247.88C1132.55 1247.88 1243.6 1309.33 1243.6 1446.33C1243.6 1583.33 1132.5 1742.23 995.575 1742.23C858.65 1742.23 747.5 1583.33 747.5 1446.33Z"
          fill="white"
        />
        <path
          d="M1208.95 1332.93C1190.6 1394.48 1121.75 1458.15 942.125 1459.65C833.625 1460.55 778.3 1434.88 751.9 1401.65C748.915 1416.35 747.441 1431.32 747.5 1446.33C747.5 1583.33 858.55 1742.23 995.55 1742.23C1132.55 1742.23 1243.6 1583.33 1243.6 1446.33C1243.62 1400 1230.97 1362.5 1208.95 1332.93Z"
          fill="#98B1DC"
        />
        <path
          d="M834.574 1461.45C834.574 1376.85 906.649 1347.1 995.574 1347.1C1084.5 1347.1 1156.57 1376.85 1156.57 1461.45C1156.57 1546.05 1084.5 1614.65 995.574 1614.65C906.649 1614.65 834.574 1546.05 834.574 1461.45Z"
          fill="#BDE5EE"
        />
        <path
          d="M834.574 1458.83C834.574 1376.15 906.649 1347.1 995.574 1347.1C1084.5 1347.1 1156.57 1376.15 1156.57 1458.83C1156.57 1541.5 1084.5 1608.5 995.574 1608.5C906.649 1608.5 834.574 1541.48 834.574 1458.83Z"
          fill={RoboyuColorTheme[colorTheme].face_body_outline}
        />
        <path
          d="M845.925 1460.15C845.925 1383.3 912.925 1356.3 995.575 1356.3C1078.22 1356.3 1145.22 1383.3 1145.22 1460.15C1145.22 1537 1078.22 1599.3 995.575 1599.3C912.925 1599.3 845.925 1537 845.925 1460.15Z"
          fill={RoboyuColorTheme[colorTheme].face_body_2}
        />
        <path
          d="M1140.32 1427.1C1123.45 1375.4 1065.05 1356.3 995.575 1356.3C912.925 1356.3 845.925 1383.3 845.925 1460.15C845.917 1469.75 846.973 1479.31 849.075 1488.68C868.825 1496.85 893.375 1503.25 923.825 1507.03C1036.2 1521.03 1108.3 1478.9 1140.32 1427.1Z"
          fill={RoboyuColorTheme[colorTheme].face_body_1}
        />
        <path
          d="M1087.75 1429.53H1070.97V1413.4H1037.82V1429.53H1019.92V1443.23H1006.42V1457.23H995.724H985.849V1442.9H971.224V1429.28H951.624V1414.33H918.474V1429.28H903.399V1483.98H922.249V1512.5H955.849V1534.8H979.099V1549.88H1012.25V1534.8H1035V1512.5H1069.22V1484.23H1087.75V1429.53Z"
          fill={RoboyuColorTheme[colorTheme].heart_hair_2}
        />
        <path
          d="M1086.92 1429.53H1070.97V1413.4H1037.82V1429.53H1020V1443.23H1006.5V1457.23H985.925V1442.9H971.3V1429.28H951.7V1414.28H918.475V1429.28H903.475V1483.98H922.325V1494.63C930.658 1496.51 939.775 1498.18 949.675 1499.63C1021.42 1509.7 1063 1472.18 1086.92 1429.53Z"
          fill={RoboyuColorTheme[colorTheme].heart_hair_1}
        />
        <path
          d="M991.175 1726.5C926.4 1726.03 876.775 1701.73 838.85 1667.23C881.575 1712.23 936.125 1742.23 995.575 1742.23C1073.4 1742.23 1142.82 1690.95 1188.3 1621.55C1147.5 1678.65 1085.2 1727.2 991.175 1726.5Z"
          fill="#BDE5EE"
        />
        <path
          d="M1005 510.202C1005 510.202 1026.32 310.002 1044.02 308.227C1061.72 306.452 1132.62 347.202 1132.62 347.202C1132.62 347.202 1214.12 253.302 1217.62 260.377C1221.12 267.452 1201.67 453.502 1192.82 457.052C1183.97 460.602 1090 432.252 1090 432.252C1090 432.252 1001.5 533.252 1005 510.202Z"
          fill={RoboyuColorTheme[colorTheme].heart_hair_2}
        />
        <path
          d="M1484.6 1015.78C1484.6 1274.1 1265.65 1274.45 995.575 1274.45C725.5 1274.45 506.55 1274.1 506.55 1015.78C506.55 757.45 725.5 548 995.575 548C1265.65 548 1484.6 757.5 1484.6 1015.78Z"
          fill="white"
        />
        <path
          d="M995.574 1274.45C1265.57 1274.45 1484.6 1274.1 1484.6 1015.78C1484.59 1000.1 1483.75 984.439 1482.1 968.852C1389.35 1073.63 1164.6 1225.1 771.649 1179.48C652.299 1165.63 571.324 1138.13 517.274 1104.05C564.424 1274.15 760.649 1274.45 995.574 1274.45Z"
          fill="#98B1DC"
        />
        <path
          d="M1410.47 1005C1410.47 1226.4 1224.72 1226.7 995.475 1226.7C766.225 1226.7 580.475 1226.4 580.475 1005C580.475 783.602 766.225 686.277 995.475 686.277C1224.72 686.277 1410.47 783.527 1410.47 1005Z"
          fill="#BDE5EE"
        />
        <path
          d="M1410.47 1001.75C1410.47 1220.93 1224.72 1221.23 995.475 1221.23C766.225 1221.23 580.475 1220.93 580.475 1001.75C580.475 782.578 766.225 686.203 995.475 686.203C1224.72 686.203 1410.47 782.503 1410.47 1001.75Z"
          fill={RoboyuColorTheme[colorTheme].face_body_outline}
        />
        <path
          d="M1396 1003.45C1396 1213.93 1216.72 1214.23 995.574 1214.23C774.424 1214.23 595.149 1213.93 595.149 1003.45C595.149 792.976 774.424 700.426 995.574 700.426C1216.72 700.426 1396 792.951 1396 1003.45Z"
          fill={RoboyuColorTheme[colorTheme].face_body_2}
        />
        <path
          d="M1389.67 938.201C1356.02 773.726 1192.37 700.426 995.574 700.426C774.424 700.426 595.149 792.926 595.149 1003.45C595.07 1019.03 596.198 1034.59 598.524 1050C637.824 1098.53 709.799 1138.08 834.874 1152.93C1138.32 1188.88 1312.62 1051.33 1389.67 938.201Z"
          fill={RoboyuColorTheme[colorTheme].face_body_1}
        />
        <path
          d="M788.85 1072.48C833.861 1072.48 870.35 1023.03 870.35 962.028C870.35 901.028 833.861 851.578 788.85 851.578C743.838 851.578 707.35 901.028 707.35 962.028C707.35 1023.03 743.838 1072.48 788.85 1072.48Z"
          fill={RoboyuColorTheme[colorTheme].eyes}
        />
        <path
          d="M1182.2 1072.48C1227.21 1072.48 1263.7 1023.03 1263.7 962.028C1263.7 901.028 1227.21 851.578 1182.2 851.578C1137.19 851.578 1100.7 901.028 1100.7 962.028C1100.7 1023.03 1137.19 1072.48 1182.2 1072.48Z"
          fill={RoboyuColorTheme[colorTheme].eyes}
        />
        <path
          d="M721.025 1354.5C757.5 1340 737.5 1478.35 731.925 1495.4C726.35 1512.45 526.1 1629.78 493.25 1610.8C460.4 1591.83 572.5 1413.8 721.025 1354.5Z"
          fill="white"
        />
        <path
          d="M737.65 1364.33C741.1 1403.15 703.125 1473.93 693.55 1485.98C682.725 1499.55 558.55 1591.48 490.225 1608.05C491.025 1609.18 492.056 1610.11 493.25 1610.8C526.1 1629.78 726.475 1512.48 731.925 1495.4C736.15 1482.13 749.275 1395.25 737.65 1364.33Z"
          fill="#98B1DC"
        />
        <path
          d="M731.924 1495.4C735.002 1482.68 737.231 1469.77 738.599 1456.75C734.624 1473.9 729.249 1493.4 726.799 1496.22C718.474 1505.77 601.799 1584.75 521.799 1607.2C513.288 1609.67 504.539 1611.24 495.699 1611.87C535.124 1624.47 726.599 1512.07 731.924 1495.4Z"
          fill="#BDE5EE"
        />
        <path
          d="M1277 1354.5C1240.6 1339.97 1260.65 1478.35 1266.1 1495.4C1271.55 1512.45 1471.92 1629.78 1504.77 1610.8C1537.62 1591.83 1425.52 1413.8 1277 1354.5Z"
          fill="white"
        />
        <path
          d="M1260.37 1364.33C1256.92 1403.15 1294.9 1473.93 1304.47 1485.98C1315.27 1499.55 1439.47 1591.48 1507.8 1608.05C1506.99 1609.17 1505.96 1610.1 1504.77 1610.8C1471.92 1629.78 1271.55 1512.48 1266.1 1495.4C1261.85 1482.13 1248.75 1395.25 1260.37 1364.33Z"
          fill="#98B1DC"
        />
        <path
          d="M1266.1 1495.4C1263.02 1482.68 1260.79 1469.77 1259.42 1456.75C1263.4 1473.9 1268.75 1493.4 1271.22 1496.22C1279.55 1505.77 1396.35 1584.75 1476.22 1607.2C1484.74 1609.67 1493.48 1611.24 1502.32 1611.87C1462.9 1624.47 1271.42 1512.07 1266.1 1495.4Z"
          fill="#BDE5EE"
        />
        <path
          d="M1132.62 347.202C1132.62 347.202 1061.75 306.452 1044.03 308.227C1026.3 310.002 1005 510.202 1005 510.202C1007.75 511.902 1085 380.552 1087.5 381.377C1090 382.202 1165 406.327 1167.5 403.002C1170 399.677 1216.38 272.502 1217.68 260.377C1214.13 253.302 1132.62 347.202 1132.62 347.202Z"
          fill={RoboyuColorTheme[colorTheme].heart_hair_1}
        />
      </g>
      <defs>
        <filter
          id="filter0_d_4220_34576"
          x="447.497"
          y="223.996"
          width="1103.03"
          height="1562.23"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB">
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="4" />
          <feGaussianBlur stdDeviation="20" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.3375 0 0 0 0 0.3375 0 0 0 0 0.3375 0 0 0 0.15 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_4220_34576"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_4220_34576"
            result="shape"
          />
        </filter>
      </defs>
    </svg>
  )
}
